import React from 'react'
import { Box, Skeleton, Stack, Card, CardContent } from '@mui/material'

/**
 * ProfileSkeleton - Loading placeholder for profile pages
 * Features:
 * - Hero section skeleton
 * - Content sections skeleton
 * - Responsive layout
 * - Smooth animations
 */
const ProfileSkeleton = () => {
  return (
    <Box>
      {/* Hero Skeleton */}
      <Skeleton
        variant="rectangular"
        height={300}
        sx={{ borderRadius: 0, mb: -10 }}
        animation="wave"
      />

      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 }, mt: -10 }}>
        <Stack direction="row" spacing={3} alignItems="flex-start">
          {/* Avatar Skeleton */}
          <Skeleton variant="circular" width={150} height={150} animation="wave" />

          {/* Info Skeleton */}
          <Box sx={{ flex: 1, pt: 4 }}>
            <Skeleton width="60%" height={40} animation="wave" />
            <Skeleton width="40%" height={24} sx={{ mt: 1 }} animation="wave" />
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Skeleton variant="rounded" width={100} height={32} animation="wave" />
              <Skeleton variant="rounded" width={120} height={32} animation="wave" />
            </Stack>
          </Box>

          {/* Stats Skeleton */}
          <Stack direction="column" spacing={2} sx={{ pt: 4 }}>
            <Skeleton variant="rounded" width={120} height={80} animation="wave" />
            <Skeleton variant="rounded" width={120} height={80} animation="wave" />
          </Stack>
        </Stack>
      </Box>

      {/* Tabs Skeleton */}
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 }, mt: 6, mb: 4 }}>
        <Stack direction="row" spacing={2}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} variant="rounded" width={100} height={48} animation="wave" />
          ))}
        </Stack>
      </Box>

      {/* Content Skeleton */}
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 } }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
          {/* Sidebar */}
          <Box sx={{ width: { xs: '100%', md: 300 } }}>
            <Card>
              <CardContent>
                <Skeleton variant="text" width="80%" height={32} animation="wave" />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{ mt: 2, borderRadius: 2 }}
                  animation="wave"
                />
              </CardContent>
            </Card>
          </Box>

          {/* Main Content */}
          <Box sx={{ flex: 1 }}>
            {[1, 2, 3].map((i) => (
              <Card key={i} sx={{ mb: 3 }}>
                <CardContent>
                  <Skeleton variant="text" width="40%" height={32} animation="wave" />
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={150}
                    sx={{ mt: 2, borderRadius: 2 }}
                    animation="wave"
                  />
                </CardContent>
              </Card>
            ))}
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}

export default ProfileSkeleton
